import { AddDailyRequest, AddReimburseRequest, AddReimburseRequestItem, AddDailyRequestItem, ApplicationTypeEnum, Approve, ApproveSet, ApproveStatusEnum, ReimburseCategory, ReimburseCategoryAdd, ReimbursRequest, RequestReimbursementItem, RequestDailyItem, ReimbursRequestStep, AddMoiRequest, MoiReimbursRequest } from "@/types/reimburse";
import request from ".";
import { CommonListParams } from "@/types/common";
import { getStorage } from "@/utils/storage";
import { OrderV2 } from "@/types/inventoryV2";

const categoryUrl = '/wms/v2/approval/reimbursement';
const templateUrl = '/wms/v2/approval/approval/step-template'
const requestUrl = '/wms/v2/approval/application'
const dailyUrl = '/wms/v2/approval/daily-supplies'
const moiUrl = '/wms/v2/approval/moi' //超领申请

export type ApproveType = "PASS" | "RETURN" | "REJECT";

const urlObj = {
  //类目
  list: categoryUrl + '/category/list',
  treeList: categoryUrl + '/category/tree',
  add: categoryUrl + '/category/add',
  subsAdd: (id: string) => `${categoryUrl}/category/${id}/subs/add`,
  update: (id: string) => `${categoryUrl}/category/${id}/update`,
  disable: (id: string) => `${categoryUrl}/category/${id}/disable`,
  fetch: (id: string) => `${categoryUrl}/category/${id}/fetch`,
  disables: `${categoryUrl}/category/disables`,
  enables: `${categoryUrl}/category/enables`,


  //模版
  templateList: templateUrl + '/list',
  templateSet: templateUrl + '/set',
  templateGet: (applicationType: ApplicationTypeEnum) => `${templateUrl}/application-type/${applicationType}`,

  //申请
  myRequestList: (status?: ApproveStatusEnum) => `${requestUrl}${status !== undefined ? '/status/' + status : ''}/my/list`,
  myApproveList: (status?: ApproveStatusEnum) => `${requestUrl}/step${status !== undefined ? '/status/' + status : ''}/list`,
  allApproveList: (status?: ApproveStatusEnum) => `${requestUrl}${status !== undefined ? '/status/' + status : ''}/list`,
  requestFetch: (id: string) => `${requestUrl}/${id}/fetch`,
  // 添加申请
  addReimburse: categoryUrl + '/create',
  reimburseUpdate: (id: string) => `${categoryUrl}/${id}/update`,

  addDaily: dailyUrl + '/create',
  dailypdate: (id: string) => `${dailyUrl}/${id}/update`,

  // items
  addReimburseItem: (id: string) => `${categoryUrl}/${id}/items/add`,
  updateReimburseItem: (id: string) => `${categoryUrl}/item/${id}/update`,
  rmReimburseItem: (id: string) => `${categoryUrl}/item/${id}/remove`,

  addDailyItem: (id: string) => `${dailyUrl}/${id}/items/add`,
  updateDailyItem: (id: string) => `${dailyUrl}/item/${id}/update`,
  rmRDailyItem: (id: string) => `${dailyUrl}/item/${id}/remove`,

  //提交
  applicationSubmit: (reSubmit: boolean, id: string) => `${requestUrl}/${id}/${reSubmit ? "resubmit" : "submit"}`,

  //通过，退回，拒绝
  doApprove: (id: string, type: ApproveType) => `${requestUrl}/step/${id}/${type === "PASS" ? "confirm" : type === "REJECT" ? "refuse" : type === "RETURN" ? "return" : ""}`,

  //超领申请
  moiSave: moiUrl + '/save',
  moiFetch: (id: string) => `${moiUrl}/${id}/fetch`,
  moiList: moiUrl + '/list',
  moiGenOrder: (id: string) => `${moiUrl}/${id}/gen_order`,

};

export const list = (params?: CommonListParams) => {
  return new Promise<CommonListParams<Array<ReimburseCategory>>>((resolve, reject) => {
    request<Array<ReimburseCategory>, string>(urlObj.list, { params })
      .then((res) => resolve({ body: res.body, pagination: res.pagination }))
      .catch((err) => reject(err));
  });
};

export const treeList = (params?: CommonListParams) => {
  return new Promise<Array<ReimburseCategory>>((resolve, reject) => {
    request<Array<ReimburseCategory>, string>(urlObj.treeList, { params })
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  });
};

export const add = (data: ReimburseCategoryAdd) => {
  return new Promise<ReimburseCategory>((resolve, reject) => {
    request<ReimburseCategory, ReimburseCategoryAdd>(urlObj.add, { params: { body: data } })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  });
};

export const subsAdd = (id: string, data: ReimburseCategoryAdd) => {
  return new Promise<ReimburseCategory>((resolve, reject) => {
    request<ReimburseCategory, ReimburseCategoryAdd>(urlObj.subsAdd(id), { params: { body: data } })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  });
};

export const update = (id: string, data: ReimburseCategoryAdd) => {
  return new Promise<void>((resolve, reject) => {
    request<void, ReimburseCategoryAdd>(urlObj.update(id), { params: { body: data } })
      .then(() => resolve())
      .catch((err) => reject(err));
  });
};

export const disable = (id: string) => {
  return new Promise<void>((resolve, reject) => {
    request<void, void>(urlObj.disable(id))
      .then(() => resolve())
      .catch((err) => reject(err));
  });
};

export const fetch = (id: string) => {
  return new Promise<ReimburseCategory>((resolve, reject) => {
    request<ReimburseCategory, string>(urlObj.fetch(id))
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  });
};

export const disables = (ids: string[]) => {
  return new Promise<void>((resolve, reject) => {
    request<void, string[]>(urlObj.disables, { params: { body: ids } })
      .then(() => resolve())
      .catch((err) => reject(err));
  });
};

export const enables = (ids: string[]) => {
  return new Promise<void>((resolve, reject) => {
    request<void, string[]>(urlObj.enables, { params: { body: ids } })
      .then(() => resolve())
      .catch((err) => reject(err));
  });
};

export const templateList = (params?: CommonListParams) => {
  return new Promise<CommonListParams<Array<Approve>>>((resolve, reject) => {
    request<Array<Approve>, string>(urlObj.templateList, { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const templateSet = (data: ApproveSet) => {
  return new Promise<Approve>((resolve, reject) => {
    request<Approve, ApproveSet>(urlObj.templateSet, { params: { body: data } })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  });
};

export const templateGet = (applicationType: ApplicationTypeEnum) => {
  return new Promise<Approve>((resolve, reject) => {
    request<Approve, undefined>(urlObj.templateGet(applicationType))
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  });
};

export const myRequestList = (status?: ApproveStatusEnum, params?: CommonListParams) => {
  return new Promise<CommonListParams<Array<ReimbursRequest>>>((resolve, reject) => {
    request<Array<ReimbursRequest>, string>(urlObj.myRequestList(status), { params, requestConfig: { headers: { org_id: getStorage('curOrgId') } } })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const myApproveList = (status?: ApproveStatusEnum, params?: CommonListParams) => {
  return new Promise<CommonListParams<Array<ReimbursRequest>>>((resolve, reject) => {
    request<Array<ReimbursRequest>, string>(urlObj.myApproveList(status), { params, requestConfig: { headers: { org_id: getStorage('curOrgId') } } })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const allApproveList = (status?: ApproveStatusEnum, params?: CommonListParams) => {
  return new Promise<CommonListParams<Array<ReimbursRequest>>>((resolve, reject) => {
    request<Array<ReimbursRequest>, string>(urlObj.allApproveList(status), { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const requestFetch = (id: string) => {
  return new Promise<ReimbursRequest>((resolve, reject) => {
    request<ReimbursRequest, undefined>(urlObj.requestFetch(id))
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  })
}

export const addReimburse = (data: AddReimburseRequest) => {
  return new Promise<ReimbursRequest>((resolve, reject) => {
    request<ReimbursRequest, AddReimburseRequest>(urlObj.addReimburse, { params: { body: data }, requestConfig: { headers: { org_id: getStorage('curOrgId') } } })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  });
};

export const reimburseUpdate = (id: string, data: AddReimburseRequest) => {
  return new Promise<ReimbursRequest>((resolve, reject) => {
    request<ReimbursRequest, AddReimburseRequest>(urlObj.reimburseUpdate(id), { params: { body: data }, requestConfig: { headers: { org_id: getStorage('curOrgId') } } })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  });
};

export const addDaily = (data: AddDailyRequest) => {
  return new Promise<ReimbursRequest>((resolve, reject) => {
    request<ReimbursRequest, AddDailyRequest>(urlObj.addDaily, { params: { body: data }, requestConfig: { headers: { org_id: getStorage('curOrgId') } } })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  });
};

export const dailypdate = (id: string, data: AddDailyRequest) => {
  return new Promise<ReimbursRequest>((resolve, reject) => {
    request<ReimbursRequest, AddDailyRequest>(urlObj.dailypdate(id), { params: { body: data }, requestConfig: { headers: { org_id: getStorage('curOrgId') } } })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  });
};

// 报销项目相关接口
export const addReimburseItem = (applicationId: string, data: AddReimburseRequestItem) => {
  return new Promise<RequestReimbursementItem>((resolve, reject) => {
    request<RequestReimbursementItem, AddReimburseRequestItem>(urlObj.addReimburseItem(applicationId), { params: { body: data } })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  });
};

export const updateReimburseItem = (itemId: string, data: AddReimburseRequestItem) => {
  return new Promise<RequestReimbursementItem>((resolve, reject) => {
    request<RequestReimbursementItem, AddReimburseRequestItem>(urlObj.updateReimburseItem(itemId), { params: { body: data } })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  });
};

export const rmReimburseItem = (itemId: string) => {
  return new Promise<void>((resolve, reject) => {
    request<void, undefined>(urlObj.rmReimburseItem(itemId))
      .then(() => resolve())
      .catch((err) => reject(err));
  });
};

// 日用品项目相关接口
export const addDailyItem = (applicationId: string, data: AddDailyRequestItem) => {
  return new Promise<RequestDailyItem>((resolve, reject) => {
    request<RequestDailyItem, AddDailyRequestItem>(urlObj.addDailyItem(applicationId), { params: { body: data } })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  });
};

export const updateDailyItem = (itemId: string, data: AddDailyRequestItem) => {
  return new Promise<RequestDailyItem>((resolve, reject) => {
    request<RequestDailyItem, AddDailyRequestItem>(urlObj.updateDailyItem(itemId), { params: { body: data } })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  });
};

export const rmRDailyItem = (itemId: string) => {
  return new Promise<void>((resolve, reject) => {
    request<void, undefined>(urlObj.rmRDailyItem(itemId))
      .then(() => resolve())
      .catch((err) => reject(err));
  });
};


export const applicationSubmit = (reSubmit: boolean, id: string) => {
  return new Promise<ReimbursRequest>((resolve, reject) => {
    request<ReimbursRequest, undefined>(urlObj.applicationSubmit(reSubmit, id))
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  });
};

export const doApprove = (id: string, type: ApproveType, body?: string) => {
  return new Promise<ReimbursRequestStep>((resolve, reject) => {
    request<ReimbursRequestStep, string | undefined>(urlObj.doApprove(id, type), { params: { body } })
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  });
};

export const moiFetch = (id: string) => {
  return new Promise<MoiReimbursRequest>((resolve, reject) => {
    request<MoiReimbursRequest>(urlObj.moiFetch(id))
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  });
};

export const moiSave = (data: AddMoiRequest) => {
  return new Promise<ReimbursRequest>((resolve, reject) => {
    request<ReimbursRequest, AddMoiRequest>(urlObj.moiSave, { params: { body: data }, requestConfig: { headers: { org_id: getStorage('curOrgId') } } })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  });
};


export const moiList = (params?: CommonListParams) => {
  return new Promise<CommonListParams<Array<ReimbursRequest>>>((resolve, reject) => {
    request<Array<ReimbursRequest>, string>(urlObj.moiList, { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const moiGenOrder = (id: string) => {
  return new Promise<OrderV2>((resolve, reject) => {
    request<OrderV2, undefined>(urlObj.moiGenOrder(id), { requestConfig: { headers: { org_id: getStorage('curOrgId') } } })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  });
};

const exportObject = {
  list,
  treeList,
  add,
  subsAdd,
  update,
  disable,
  fetch,
  templateList,
  templateSet,
  templateGet,
  myRequestList,
  myApproveList,
  allApproveList,
  requestFetch,
  addReimburse,
  reimburseUpdate,
  addDaily,
  dailypdate,
  addReimburseItem,
  updateReimburseItem,
  rmReimburseItem,
  addDailyItem,
  updateDailyItem,
  rmRDailyItem,
  applicationSubmit,
  doApprove,
  moiList,
  moiFetch,
  moiSave,
  moiGenOrder,
};

export default exportObject;
